import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=88596636&scoped=true"
import script from "./VerifyEmail.vue?vue&type=script&lang=ts"
export * from "./VerifyEmail.vue?vue&type=script&lang=ts"
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&id=88596636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88596636",
  null
  
)

export default component.exports